var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"ma-4",attrs:{"type":"error","border":"left"}},[_vm._v(" "+_vm._s(_vm.$route.path + ' 존재하지 않는 경로입니다')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }